const cropNameLookup = {
  en: {
    alfalfa: 'Alfalfa',
    'artichoke 1st round': 'Artichoke (Feb.-Apr. planting)',
    'artichoke 2nd round': 'Artichoke (Aug. planting)',
    barley: 'Barley',
    'broad beans': 'Broad beans',
    broccoli: 'Broccoli',
    corn: 'Corn',
    'corn 1st round': 'Corn (Aug.-Sept. planting)',
    'corn 2nd round': 'Corn (Dec.-Jan. planting)',
    garlic: 'Garlic',
    'green beans': 'Green beans',
    lettuce: 'Lettuce',
    onion: 'Onion',
    peas: 'Peas',
    potato: 'Potato',
    'potato 1st round': 'Potato (Feb.-Mar. planting)',
    'potato 2nd round': 'Potato (Aug.-Sept. planting)',
    'pumpkin 1st round': 'Pumpkin (Feb.-Mar. planting)',
    'pumpkin 2nd round': 'Pumpkin (Aug.-Sept. planting)',
    'red onion 1st round': 'Red onion (Mar.-Apr. planting)',
    'red onion 2nd round': 'Red onion (Aug.-Sept. planting)',
    tomato: 'Tomato',
    quinoa: 'Quinoa',
  },
  es: {
    alfalfa: 'Alfalfa',
    'artichoke 1st round': 'Alcachofa (siembra en feb-abr)',
    'artichoke 2nd round': 'Alcachofa (siembra en ago)',
    barley: 'Cebada',
    'broad beans': 'Habas',
    broccoli: 'Brócoli',
    corn: 'Maiz',
    'corn 1st round': 'Maiz (siembra en ago-sep)',
    'corn 2nd round': 'Maiz (siembra en dic-ene)',
    garlic: 'Ajo',
    'green beans': 'Vainas verdes',
    lettuce: 'Lechuga',
    onion: 'Cebolla',
    peas: 'Arveja',
    potato: 'Papa',
    'potato 1st round': 'Papa (siembra en feb-mar)',
    'potato 2nd round': 'Papa (siembra en ago-sep)',
    'pumpkin 1st round': 'Calabaza (siembra en feb-mar)',
    'pumpkin 2nd round': 'Calabaza (siembra en ago-sep)',
    'red onion 1st round': 'Cebolla roja (siembra en mar-abr)',
    'red onion 2nd round': 'Cebolla roja (siembra en ago-sep)',
    tomato: 'Tomate',
    quinoa: 'Quinua',
  },
  qu: {
    alfalfa: 'TRANSLATE',
    'artichoke 1st round': 'TRANSLATE',
    'artichoke 2nd round': 'TRANSLATE',
    barley: 'Cebada',
    'broad beans': 'Habas',
    broccoli: 'TRANSLATE',
    corn: 'Sara',
    'corn 1st round': 'TRANSLATE',
    'corn 2nd round': 'TRANSLATE',
    garlic: 'TRANSLATE',
    'green beans': 'TRANSLATE',
    lettuce: 'TRANSLATE',
    onion: 'TRANSLATE',
    peas: 'Alverjas',
    potato: 'Papa',
    'potato 1st round': 'TRANSLATE',
    'potato 2nd round': 'TRANSLATE',
    'pumpkin 1st round': 'TRANSLATE',
    'pumpkin 2nd round': 'TRANSLATE',
    'red onion 1st round': 'TRANSLATE',
    'red onion 2nd round': 'TRANSLATE',
    tomato: 'TRANSLATE',
    quinoa: 'Kinuwa',
  },
};

export default function getCropName(lang, crop) {
  return cropNameLookup[lang][crop];
}
